import React, { createContext } from "react";
import { useStackManager } from "../../hooks/useStackManager";
import { ConfirmModal } from "./ConfirmModal";

export const ModalCtx = createContext({
  updateItem: () => console.error("[ModalCtx.updateItem] missing context"),
  destroyItem: () => console.error("[ModalCtx.destroyItem] missing context"),
});

const mapModalExtraProps = ({ buttons, getButtons }, { onClose }) => ({
  buttons: getButtons?.({ onClose }) || buttons,
});

export const ModalProvider = ({ children }) => {
  const { stack, ctx, mapProps } = useStackManager({
    mapExtraProps: mapModalExtraProps,
  });

  return (
    <ModalCtx.Provider value={ctx}>
      {children}
      <div style={{ position: "absolute" }}>
        {stack.map((item) => (
          <ConfirmModal {...mapProps(item)} />
        ))}
      </div>
    </ModalCtx.Provider>
  );
};

// Re-export for backward compatibility
export { useModal } from "./useModal";
